export { PendingRequestIcon } from './PendingRequestIcon';
export { PhoneIcon } from './PhoneIcon';
export { Zoom } from './Zoom';
export { Webex } from './Webex';
export { GoogleMeet } from './GoogleMeet';
export { MicrosoftTeam } from './MicrosoftTeam';
export { ZoomSmall } from './ZoomSmall';
export { Microsoft } from './Microsoft';
export { RemoteControllerIcon } from './RemoteController';
